/**
 * Detects if the code is running in browser extension environment.
 * This utility can be used to conditionally import or use features that are not available in extensions.
 */
export const isExtensionEnvironment = (): boolean => {
  return !!(
    (typeof browser !== "undefined" && browser?.runtime?.getURL) ||
    (typeof chrome !== "undefined" && chrome?.runtime?.getURL)
  );
};

/**
 * Detects if the code is running in a web/desktop environment (not extension).
 */
export const isWebOrDesktopEnvironment = (): boolean => {
  return !isExtensionEnvironment();
};
